<div class="chart-container" *ngIf="chartDatasets.length > 0">
  <canvas baseChart
    [type]="chartType"
    [datasets]="chartDatasets"
    [labels]="chartLabels"
    [options]="chartOptions">
  </canvas>
</div>
